export const getSurgeonDisplayName = (item: any): string => {
  if (item.alignedSurgeonName) {
    return item.alignedSurgeonName;
  }
  if (item.surgeonFirstName) {
    return `${item.surgeonFirstName} ${item.surgeonLastName}`;
  }
  return '--';
};
